export function Navbar({children}) {
    return (
      <div>
       {children}
      </div>
    );
  };

export function CloseButton(props) {
    return (
        <img src={"/img/cancel/cancel-"+props.colourCode+"-512.png"} style={{height: "2em", width: "2em"}} onClick={props.closer}/>
    )
}

function PopupButton(props) {
    return (
        <img src={props.image} style={{height: "1.2em", width: "1.2em"}} onClick={props.popup}/>
    )
}

export function SettingsButton(props) {
    return (
        <PopupButton image={"/img/graph/graph-"+props.colourCode+"-512.png"} popup={props.popup}/>
    )
}

export function HelpButton(props) {
    return (
        <PopupButton image={"/img/question/question-"+props.colourCode+"-512.png"} popup={props.popup}/>
    )
}

export function RestartButton(props) {
    return (
        <PopupButton 
            image={props.enabled ? "/img/restart/restart-"+props.colourCode+"-512.png" : "/img/restart/restart-"+props.disabledColourCode+"-512.png"}
            popup={props.enabled ? props.popup : ()=>{}}
        />
    )
}

export function ShareButton(props) {
    return (
        <div style={{marginTop: "3em", textAlign: "center"}}>
            <button type="button" className={"online-game-button " + props.gameButtonClass} onClick={props.onShare}>Share</button>
        </div>        
    )
}